import React, {useState,useEffect} from "react";
import axios  from "axios";
import List from "./components/List";

function App() {

  const [data, setData] = useState([])
  const [count, setCount] = useState(1)


  useEffect(() => {
    api()
  }, [count])
  
  // const {data} = await axios(`https://rickandmortyapi.com/api/character?page=${count}`)

  const api = async() => {
    try {
      fetch(`https://rickandmortyapi.com/api/character?page=${count}`)
      .then(res_api => res_api.json())
        .then((res) => setData(res.results))
    } catch (error) {
      console.log(error)
    }
  }

  const handleContadorNext = () => {
      setCount(count + 1)
   }

  const handleContadorBack = () => {
    setCount(count - 1)
  }
  
  console.log(data)


  return (
    <div className="container">
      <h1 className="titulo">Api Rick Y Morty</h1>
      <div className="boton">
          <button disabled={count <= 1} className={`${count <= 1 ? 'boton_back' : 'boton_nav'}`} onClick={handleContadorBack}>Back</button>
          <button className="boton_nav" onClick={handleContadorNext}>Next</button>  
        </div>
      <div className="grid">
        <List data={data}/>
      </div>
    </div>
  );
}

export default App;
